window.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.add-all-to-cart');
  if (!button || !window.featuredCollectionVariants) return;

  button.addEventListener('click', async () => {
    button.disabled = true;
    button.textContent = 'Ajout en cours...';

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            items: window.featuredCollectionVariants
            })
        });

        if (!response.ok) throw new Error('Erreur lors de l\'ajout au panier. Réessayez.');

        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'featured-collection',
            cartData: {
                sections: ['cart-drawer', 'cart-icon-bubble']
            }
        });

        const cartDrawerEmpty = document.querySelector('.drawer__inner-empty');
        if (cartDrawerEmpty) cartDrawerEmpty.parentNode.removeChild(cartDrawerEmpty);
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.classList.remove('is-empty');
        cartDrawer.open();

    } catch (error) {
      alert('Impossible d’ajouter les produits au panier. Réessayez.');
    } finally {
      button.disabled = false;
      button.textContent = button.dataset.defaultLabel;
    }
  });
});